// import React, { useState } from 'react';
// import { 
//     AppBar, 
//     Toolbar, 
//     Typography, 
//     Box, 
//     Button, 
//     IconButton, 
//     Drawer, 
//     List, 
//     ListItem, 
//     ListItemButton, 
//     ListItemText 
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import { motion } from 'framer-motion';

// // Import your logo from its actual path
// import logo from "../../Assets/Images/Image.jpg"

// const navItems = [
//     { label: 'Home', href: '/' },
//     { label: 'About', href: '/about' },
//     { label: 'Services', href: '/services' },
//     { label: 'Contact', href: '/contact' },
// ];

// export default function Header() {
//     const [mobileOpen, setMobileOpen] = useState(false);

//     const handleDrawerToggle = () => {
//         setMobileOpen((prevState) => !prevState);
//     };

//     const drawer = (
//         <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', width: 240 }}>
//             <Typography variant="h6" sx={{ my: 2 }}>
//                 Vediverse
//             </Typography>
//             <List>
//                 {navItems.map((item) => (
//                     <ListItem key={item.label} disablePadding>
//                         <ListItemButton component="a" href={item.href} sx={{ textAlign: 'center' }}>
//                             <ListItemText primary={item.label} />
//                         </ListItemButton>
//                     </ListItem>
//                 ))}
//             </List>
//         </Box>
//     );

//     return (
//         <AppBar
//             component="nav"
//             position="sticky"
//             sx={{
//                 backgroundColor: '#ffffff',
//                 color: 'text.primary',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                 borderBottom: '1px solid rgba(0,0,0,0.12)'
//             }}
//         >
//             <Toolbar sx={{ justifyContent: 'space-between' }}>
//                 {/* Logo and Title */}
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                     <motion.div whileHover={{ scale: 1.1, rotate: 10 }}>
//                         {/* This is the correct way to display your imported logo */}
//                         <img 
//                             src={logo} 
//                             alt="Vediverse Logo" 
//                             style={{ 
//                                 height: 40, 
//                                 width: 40, 
//                                 marginRight: 12, 
//                                 borderRadius: "50%",
//                                 objectFit: 'cover' // Ensures the image fits well within the circle
//                             }} 
//                         />
//                     </motion.div>
//                     <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
//                         Vediverse
//                     </Typography>
//                 </Box>

//                 {/* Mobile Menu Icon */}
//                 <IconButton
//                     color="inherit"
//                     aria-label="open drawer"
//                     edge="end"
//                     onClick={handleDrawerToggle}
//                     sx={{ display: { sm: 'none' } }}
//                 >
//                     <MenuIcon />
//                 </IconButton>

//                 {/* Desktop Navigation Links */}
//                 <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
//                     {navItems.map((item) => (
//                         <Button
//                             key={item.label}
//                             component="a"
//                             href={item.href}
//                             sx={{
//                                 color: 'text.primary',
//                                 fontWeight: 500,
//                                 textTransform: 'none',
//                                 fontSize: '1rem',
//                                 ml: 2,
//                                 '&:hover': {
//                                     color: 'primary.main',
//                                     backgroundColor: 'transparent',
//                                 },
//                             }}
//                         >
//                             {item.label}
//                         </Button>
//                     ))}
//                 </Box>
//             </Toolbar>
            
//             {/* Mobile Drawer */}
//             <Drawer
//                 variant="temporary"
//                 open={mobileOpen}
//                 onClose={handleDrawerToggle}
//                 ModalProps={{
//                     keepMounted: true, // Better open performance on mobile.
//                 }}
//                 anchor="right"
//                 sx={{
//                     display: { xs: 'block', sm: 'none' },
//                     '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
//                 }}
//             >
//                 {drawer}
//             </Drawer>
//         </AppBar>
//     );
// }


import React, { useState } from 'react';
import { 
    AppBar, 
    Toolbar, 
    Typography, 
    Box, 
    Button, 
    IconButton, 
    Drawer, 
    List, 
    ListItem, 
    ListItemButton, 
    ListItemText 
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { motion } from 'framer-motion';
// 1. Import useLocation from react-router-dom
import { useLocation } from 'react-router-dom';

// Import your logo from its actual path
import logo from "../../Assets/Images/Image.jpeg"

const navItems = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Contact', href: '/contact' },
];

export default function Header() {
    const [mobileOpen, setMobileOpen] = useState(false);
    // 2. Get the current location's pathname
    const { pathname } = useLocation();

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', width: 240 }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                Vediverse
            </Typography>
            <List>
                {navItems.map((item) => (
                    <ListItem key={item.label} disablePadding>
                        <ListItemButton 
                            component="a" 
                            href={item.href} 
                            sx={{ textAlign: 'center' }}
                            // 3. Apply 'selected' style if the path matches
                            selected={pathname === item.href}
                        >
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <AppBar
            component="nav"
            position="sticky"
            sx={{
                backgroundColor: '#ffffff',
                color: 'text.primary',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                borderBottom: '1px solid rgba(0,0,0,0.12)'
            }}
        >
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                {/* Logo and Title */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <motion.div whileHover={{ scale: 1.1, rotate: 10 }}>
                        <img 
                            src={logo} 
                            alt="Vediverse Logo" 
                            style={{ 
                                // height: 80, 
                                width: 120, 
                                marginRight: 12, 
                                borderRadius: "5%",
                                objectFit: 'cover'
                            }} 
                        />
                    </motion.div>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                        Vediverse
                    </Typography>
                </Box>

                {/* Mobile Menu Icon */}
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="end"
                    onClick={handleDrawerToggle}
                    sx={{ display: { sm: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>

                {/* Desktop Navigation Links */}
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    {navItems.map((item) => (
                        <Button
                            key={item.label}
                            component="a"
                            href={item.href}
                            sx={{
                                // 4. Conditionally set the style for the active link
                                color: pathname === item.href ? 'primary.main' : 'text.primary',
                                fontWeight: pathname === item.href ? 'bold' : 500,
                                textTransform: 'none',
                                fontSize: '1rem',
                                ml: 2,
                                '&:hover': {
                                    color: 'primary.main',
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            {item.label}
                        </Button>
                    ))}
                </Box>
            </Toolbar>
            
            {/* Mobile Drawer */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
                anchor="right"
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
                }}
            >
                {drawer}
            </Drawer>
        </AppBar>
    );
}